import { CCol, CRow } from '@coreui/react';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LoadingButton from "../../shared/components/LoadingButton";
import { selectUserProfile } from '../../store/selectors/profile.selectors';
import { UserRoles } from '../../shared/models/user';
import { SyncSubscriptionStatus } from '../../store/actions/billing.action';
import chargebeeCheckoutHandler from '../../shared/utils/chargebee-utils';
import { selectUserOrganization } from '../../store/selectors/store.selectors';

const NonAdminSubscribePageContent = () => {
  const adminEmail = useSelector(selectUserOrganization)?.admin_email;
  return (
    <CRow>
      <CCol className="flex-column flex-center">
        <p className="text-center">The Glympse PRO beta program is over and your beta user license has expired.</p>
        <p className="text-center">{`In order to continue using Glympse PRO, you will need to update your payment information and activate new license(s). Please contact your company's administrator${adminEmail ? `: ${adminEmail}` : ''} to do this.`}</p>
      </CCol>
    </CRow>
  );
};

const AdminSubscribePageContent = ({handleSubscribeOnClick}: {handleSubscribeOnClick: () => void}) => {
  return (
    <CRow>
      <CCol className="flex-column flex-center">
        <h1 className="text-center">Your Account is Verified</h1>
        <p className="text-center">You have successfully verified your account setup. Thank you!</p>
        <p className="text-center">As a next step, you will need to enter your billing information. Don’t worry, you do not need to enter credit card details at this time. You won’t be charged until the end of your free trial period.</p>
        <p className="text-center">And remember, you can cancel your Glympse PRO subscription anytime.</p>
        <LoadingButton
          size="lg"
          className="bg-color-orange border-0"
          onClick={handleSubscribeOnClick}
          isLoading={false}
        >
          Setup Billing Information
        </LoadingButton>
      </CCol>
    </CRow>
  );
}


const AccountVerified = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const profile = useSelector(selectUserProfile);
  const isAdmin = profile?.roles?.indexOf(UserRoles.Admin) > -1;
  const isSucceededRef = useRef(false);

  const successCallback = (hostedPageId) => {
    isSucceededRef.current = true;
    dispatch(new SyncSubscriptionStatus(hostedPageId));
  };

  const closeCallback = () => {
    if (isSucceededRef.current) {
      history.push('/account-billing-complete');
    }
  };

  return (
    isAdmin ?
      <AdminSubscribePageContent handleSubscribeOnClick={() => chargebeeCheckoutHandler(profile, successCallback, closeCallback)} /> :
      <NonAdminSubscribePageContent/>
  );
};

export default AccountVerified;
